<template>
  <mdb-container v-if="response">
    <div>
      <mdb-card>
        <mdb-card-header>
          <h4>Completed by {{response.userName}} on {{response.submitted}}</h4>
          <router-link v-if="response.userId" :to="'/users/' + response.userId">User Profile</router-link>
        </mdb-card-header>
        <mdb-card-body>
          <div :class="(response.adminAcknowledged ? 'text-success' : 'text-danger')"
               @click.prevent="toggleAck"
               style="cursor:pointer;">
            <mdb-icon icon="check" v-if="response.adminAcknowledged"/>
            <mdb-icon icon="ban" v-if="!response.adminAcknowledged"/>
            Admin Acknowledged
          </div>
          <custom-data :custom-data="response.fields" :allow-edit="false"/>
        </mdb-card-body>
      </mdb-card>
    </div>

  </mdb-container>
</template>

<script>

import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import CustomData from "../common/CustomData";

export default {
  name: 'form-response',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbIcon,
    mdbBtn,
    CustomData
  },
  props: {
    responseId : {
      type: String,
      default: null
    }
  },
  data() {
    return {
      response: null
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    api.get("/customForm/showResponse/" + this.responseId).then(
      (results) => {
        this.response = results.data
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 5000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    toggleAck() {
      this.$store.dispatch("setExecuting", true)
      api.get("/customForm/toggleAck/" + this.responseId).then(
        (results) => {
          this.response.adminAcknowledged = !this.response.adminAcknowledged
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }

  }

}
;
</script>
